import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";
import moment from "moment";

import { Button } from "@/components/ui/button";

export function TicketingUpdatedAtField({ id, label }: AutoFormFieldProps) {
  const form = useFormContext();
  const value = useWatch({ name: id });

  return (
    <div className="flex flex-col space-y-2">
      <div className="text-sm text-muted-foreground">
        {label}: {value ? moment(value).format() : "—"}
      </div>
      <div className="flex flex-row-reverse w-full">
        <Button
          type="button"
          variant="destructive"
          onClick={() => {
            form.setValue("ticketing", null, { shouldDirty: true });
          }}
        >
          Remove Ticketing
        </Button>
      </div>
    </div>
  );
}
